module.exports = {"apiUrl":"https://api.rankyapp.fr"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 36
// module chunks = 0